import { z } from 'zod';

const articleAuthorSection = z.object({
  label: z.string(),
  href: z.string(),
});

const articleAuthorLocaleSchema = z.object({
  degree: z.string().max(100),
  description: z.string(),
  sections: z.array(articleAuthorSection),
});

export const articleAuthorSchema = z.object({
  id: z.number().int().positive().optional(),
  name: z.string().min(1, 'Name is required').max(100),
  slug: z.string().min(1, 'Slug is required'),
  content: z.object({
    en: articleAuthorLocaleSchema,
    es: articleAuthorLocaleSchema,
  }),
  picture: z.string().optional().nullable(),
});

export type ArticleAuthorInput = z.infer<typeof articleAuthorSchema>;
